import { Box, CardContent, Typography } from '@mui/material'
import { isEmpty, pickBy } from 'lodash'
import { useTranslate } from 'ra-core'
import { useEffect, useMemo } from 'react'

import VehicleTypeUtilisation from './VehicleTypeUtilisation'
import { useApi } from '../../api/apiProvider'
import { useCommonStyles } from '../../config/theme'
import { VEHICLE_TYPES } from '../../config/vehicles'
import { getDefaultBrushIndexes, mergePressureSeries } from '../../utils/pressureGraph'
import { CardTitle } from '../common'
import { ShowCard } from '../common/show'

const getPointsAroundNow = (data, now) => {
  if (isEmpty(data?.total)) return []
  const points = mergePressureSeries(data.total, data.used)
  const { startIndex, endIndex } = getDefaultBrushIndexes(points, now)
  return points.slice(Math.max(startIndex, 0), endIndex + 1)
}

const UtilisationOverview = ({ organisationId, hubId }) => {
  const commonClasses = useCommonStyles()
  const translate = useTranslate()
  const [fetchPressure, { data }] = useApi(`/organisations/pressure/${organisationId}`, {
    params: pickBy({ hub_id: hubId }),
  })

  useEffect(() => {
    fetchPressure()
  }, [fetchPressure])

  const { now, vehicleTypesWithData } = useMemo(() => {
    const now = Date.now()
    const vehicleTypesWithData = VEHICLE_TYPES.map((vehicleType) => ({
      vehicleType,
      points: getPointsAroundNow(data?.[vehicleType], now),
    })).filter(({ points }) => !isEmpty(points))
    return { now, vehicleTypesWithData }
  }, [data])

  if (isEmpty(vehicleTypesWithData)) return null

  return (
    <ShowCard>
      <CardContent sx={{ borderBottom: '1px solid', borderColor: 'divider', ...commonClasses.titleContainer }}>
        <Box>
          <CardTitle text="mymove.statistics.utilisation.title" />
          <Typography variant="body2" color="text.secondary">
            {translate('mymove.statistics.utilisation.subtitle')}
          </Typography>
        </Box>
      </CardContent>
      <CardContent>
        <Box display="grid" gridTemplateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={2}>
          {vehicleTypesWithData.map(({ vehicleType, points }) => (
            <VehicleTypeUtilisation key={vehicleType} vehicleType={vehicleType} points={points} now={now} />
          ))}
        </Box>
      </CardContent>
    </ShowCard>
  )
}

export default UtilisationOverview
